import script from "./Logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo.vue?vue&type=script&setup=true&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=4e9283df&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e9283df"]])

export default __exports__